<template>
  <default-card>
    <template slot="title-left"> Financeiro 💰 </template>
    <template slot="title-right"> </template>
    <template slot="content">
      <v-row cols="12" justify="center" class="pb-3">
        <v-col cols="12" lg="4" md="12" small="12" class="pa-0">
          <card-loading-transparent v-if="loadings.income" card_color="white" text_color="primary--text" loading_color="primary"/>
          <received :data="all_data.income" v-if="!loadings.income"/>
        </v-col>
        <v-col cols="12" lg="4" md="12" small="12" class="pa-0">
          <card-loading-transparent v-if="loadings.outcome" card_color="white" text_color="primary--text" loading_color="primary"/>
          <expenditure :data="all_data.outcome" v-if="!loadings.outcome"/>
        </v-col>
        <v-col cols="12" lg="4" md="12" small="12" class="pa-0">
          <card-loading-transparent v-if="loadings.outcome" card_color="white" text_color="primary--text" loading_color="primary"/>
          <balance-avaliable :data="all_data.balance" v-if="!loadings.balance"/>
        </v-col>
      </v-row>
    </template>
    <template slot="actions"> </template>
  </default-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Received from './finance_cards/Received.vue'
import Expenditure from './finance_cards/Expenditure.vue'
import BalanceAvaliable from './finance_cards/BalanceAvaliable.vue'
import Api from '@/api'

export default {
  name: 'HomeFinancialInfo',
  components: {
    Received,
    Expenditure,
    BalanceAvaliable,
  },
  data() {
    return {
      loadings: {
        income: false,
        outcome: false,
        balance: false,
      },
      all_data: {
        income: null,
        outcome: null,
        balance: null,
      }
    }
  },
  methods: {
    getData(){
      this.getIncome()
      this.getOutcome()
      this.getBalance()
    },
    getIncome(filter){
      this.getDashCounter('income', filter)
    },
    getOutcome(filter){
      this.getDashCounter('outcome', filter)
    },
    getBalance(filter){
      this.getDashCounter('balance', filter)
    },
    getDashCounter(kind, filter = {}){
      this.loadings[kind] = true
      Api.DashCounter.showByCompany(this.activeCompanyId, kind, filter).then(r=>r.data).then(d=>{
        this.all_data[kind] = d
      }).catch((err) => {
        console.log(err);
      }).finally(()=>{
        this.loadings[kind] = false
      })
    },
    
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId,
      user: state => state.User.user
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getData()
  },
  watch: {
    activeCompanyId(){
      this.getData()
    }
  },
}
</script>

<style lang="scss">
</style>